import { executeCapability } from '../utils/capabilityExecute'

export interface PortalMailSettings {
  fromAddress: string
  fromName: string
  signatureHtml: string
  resolvedFromAddress: string
  resolvedFromName: string
  fromSource: 'setting' | 'env' | 'none' | string
  googleConfigured: boolean
  updatedAt: string | null
}

export const portalMailService = {
  async get(): Promise<PortalMailSettings> {
    return executeCapability<PortalMailSettings>({
      app: 'admin',
      capability: 'portalMail.settings.get',
      input: {},
    })
  },

  async update(input: { fromAddress?: string; fromName?: string; signatureHtml?: string }): Promise<PortalMailSettings> {
    return executeCapability<PortalMailSettings>({
      app: 'admin',
      capability: 'portalMail.settings.update',
      input,
    })
  },

  async sendTest(to: string): Promise<{ sent: boolean }> {
    return executeCapability<{ sent: boolean }>({
      app: 'admin',
      capability: 'portalMail.settings.sendTest',
      input: { to },
    })
  },
}
